export interface TaskListRequest {
  mindId: string;
  userTaskName?: string;
}

export enum TaskType {
  DIALOGUE = 'DIALOGUE',
  TIMER = 'TIMER'
}

export enum TaskState {
  NOT_EXECUTED = 'NOT_EXECUTED',
  EXECUTING = 'EXECUTING',
  COMPLETED = 'COMPLETED'
}

export interface TaskData {
  id: number;
  gmtCreate: string;
  gmtModified: string;
  type: TaskType;
  sessionId: string;
  userId: string;
  mindId: string;
  state: TaskState;
  title: string;
  subtaskList: SubtaskData[];
  hasTodoLabel: boolean;
}

export interface SubtaskData {
  id: number;
  gmtCreate: string;
  gmtModified: string;
  messageId: string;
  taskId: string;
  subtaskName: string;
  content: string[];
}
